import { useContext } from 'react';
import { RemoteConfigContext } from '../../providers/RemoteConfigProvider';

export const useRemoteConfigFlag = () => useContext(RemoteConfigContext);
